import React, { useEffect } from "react";
import { connect } from "react-redux";

import logo from "assets/images/mirror_logo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import { deepCompare, epocToDate, sortArray } from "utils";

function Header(props) {
  const userDetails = props.userDetails;
  const [finalHtmlContent, setFinalHtmlContent] = React.useState([]);
  const [pdfDisabled, setPdfDisabled] = React.useState(false);
  const [pdfReady, setPdfReady] = React.useState(false);
  const [downloadFile, setDownloadFile] = React.useState(false);
  const [doc, setDoc] = React.useState(null);

  //235 width and 397 height .Can be changed later....
  const docInstance = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: [235, 397]
  });

  React.useLayoutEffect(() => {
    // Generate HTML content for each JSX element
    let jsxContent = jsxContentCreator();
    const htmlContentArray = jsxContent.map(jsx => {
      return ReactDOMServer.renderToString(jsx);
    });

    setFinalHtmlContent(htmlContentArray);
    setPdfDisabled(() => {
      if (props.activities.length === 0) {
        return true;
      }
    });
  }, []);

  React.useLayoutEffect(() => {
    const convertJsxIntoCanvas = async () => {
      const element = document.createElement("div");
      element.style.width = "980px";
      document.body.appendChild(element);
      for (let i = 0; i < finalHtmlContent.length; i++) {
        const htmlContent = finalHtmlContent[i];

        element.innerHTML = htmlContent;

        await html2canvas(element, { scale: 1.2 })
          .then(canvas => {
            const imgData = canvas.toDataURL("image/png");

            var imgWidth = 235;

            var imgHeight = (canvas.height * imgWidth) / canvas.width;

            //for first page....
            if (i === 0) {
              docInstance.addImage(
                imgData,
                "PNG",
                0,
                0,
                imgWidth,
                imgHeight,
                undefined,
                "FAST"
              );
            }

            //From second page onwards.....
            if (i > 0) {
              docInstance.addPage();
              docInstance.addImage(
                imgData,
                "PNG",
                0,
                0,
                imgWidth,
                imgHeight,
                undefined,
                "FAST"
              );
            }
          })
          .catch(error => {
            document.body.removeChild(element);
          });
        if (i === finalHtmlContent.length - 1) {
          setDoc(docInstance);
          setPdfReady(prevState => {
            const updatedState = !prevState;

            return updatedState;
          });
        }
      }
      document.body.removeChild(element);
    };

    if (finalHtmlContent.length !== 0) {
      convertJsxIntoCanvas();
    }
  }, [finalHtmlContent]);

  useEffect(() => {
    if (downloadFile && pdfReady) {
      doc.save(
        "sessionLogs-" +
          epocToDate(props.enterDates.startDate.value, "MMddyyyy") +
          "-to-" +
          epocToDate(props.enterDates.endDate.value, "MMddyyyy")
      );

      setPdfDisabled(prevState => {
        if (prevState) {
          return false;
        } else {
          return prevState;
        }
      });
      setDownloadFile(prevState => {
        if (prevState) {
          return false;
        } else {
          return prevState;
        }
      });
    }
  }, [downloadFile, pdfReady]);

  const constantJSX = element => {
    return (
      <div className="pdf_tb_rw columns_3">
        <div className="pdf_td description_col col_width_1">
          <span className="td_desc"> {element.description}</span>
        </div>
        <div className="pdf_td date_col col_width_2">
          <span className="td_desc">
            {epocToDate(element.date, "MM-dd-yyyy, hh:mm:ss")}
          </span>
        </div>
        <div className="pdf_td ipaddress_col col_width_2">
          <span className="td_desc">{element.remoteAddress}</span>
        </div>
      </div>
    );
  };

  //for creating array of jsx depending upon pages...
  const jsxContentCreator = () => {
    //First page has 33 logs and Header....
    let firstPageLogs = props.activities.slice(0, 33);

    //From Second Page  36 logs per page.....
    let logsFromSecondPage = props.activities.slice(
      33,
      props.activities.length
    );

    let numberPages = Math.ceil(logsFromSecondPage.length / 36 + 1);

    let logsFromSecondPageTemp = [];
    const jsxContentArray = [];

    for (let i = 0; i < numberPages; i++) {
      //First page...
      if (i === 0) {
        jsxContentArray.push(
          <div className="pdf_container_wrapper">
            <div className="pdf_container_body">
              <div className="pdf_header">
                <div className="pdf_logo">
                  <img src={logo} />
                </div>
                <div className="pdf_label">{userDetails.firstname}</div>
              </div>
              <div className="pdf_body">
                <section className="pdf_section table_section alarm_section">
                  <h3 className="h3_title heading">
                    <p className="pdf_p">
                      The following are the session logs for the user{" "}
                      <b>{userDetails.firstname}</b> from{" "}
                      <b>
                        {epocToDate(
                          props.enterDates.startDate.value,
                          "MM-dd-yyyy"
                        )}
                      </b>{" "}
                      till{" "}
                      <b>
                        {epocToDate(
                          props.enterDates.endDate.value,
                          "MM-dd-yyyy"
                        )}
                      </b>
                      .
                    </p>
                  </h3>

                  <div className="custom_table computer_table alarm_table remove_padding">
                    <ul className="pdf_table">
                      <li className="pdf_tb_head">
                        <div className="pdf_tb_rw columns_3">
                          <div className="pdf_td description_col col_width_1">
                            <span className="td_desc"> Description</span>
                          </div>
                          <div className="pdf_td date_col col_width_2">
                            <span className="td_desc">Date</span>
                          </div>
                          <div className="pdf_td ipaddress_col col_width_2">
                            <span className="td_desc">IP Address</span>
                          </div>
                        </div>
                      </li>
                      <li className="pdf_tb_body">
                        {props.activities &&
                          sortArray(
                            firstPageLogs,
                            "date",
                            props.sortByDate
                          ).map(element => constantJSX(element))}
                      </li>
                    </ul>
                  </div>
                </section>
              </div>
            </div>
          </div>
        );
      }

      //Second Page...
      else {
        if (logsFromSecondPage.length >= 36) {
          logsFromSecondPageTemp = logsFromSecondPage.slice(0, 36);
          logsFromSecondPage.splice(0, 36);
        } else {
          logsFromSecondPageTemp = logsFromSecondPage.slice(
            0,
            logsFromSecondPage.length
          );
        }

        jsxContentArray.push(
          <div className="pdf_container_wrapper">
            <div className="pdf_container_body">
              <div className="pdf_body">
                <section className="pdf_section table_section alarm_section">
                  <div className="custom_table computer_table alarm_table remove_padding">
                    <ul className="pdf_table">
                      <li className="pdf_tb_head">
                        <div className="pdf_tb_rw columns_3">
                          <div className="pdf_td description_col col_width_1">
                            <span className="td_desc"> Description</span>
                          </div>
                          <div className="pdf_td date_col col_width_2">
                            <span className="td_desc">Date</span>
                          </div>
                          <div className="pdf_td ipaddress_col col_width_2">
                            <span className="td_desc">IP Address</span>
                          </div>
                        </div>
                      </li>
                      <li className="pdf_tb_body">
                        {sortArray(
                          logsFromSecondPageTemp,
                          "date",
                          props.sortByDate
                        ).map(element => constantJSX(element))}
                      </li>
                    </ul>
                  </div>
                </section>
              </div>
            </div>
          </div>
        );
      }
    }

    return jsxContentArray;
  };

  function downloadPDF() {
    if (pdfReady) {
      doc.save(
        "sessionLogs-" +
          epocToDate(props.enterDates.startDate.value, "MMddyyyy") +
          "-to-" +
          epocToDate(props.enterDates.endDate.value, "MMddyyyy")
      );
    } else {
      setDownloadFile(true);
      setPdfDisabled(true);
    }
  }

  return (
    <div className={"web_logs_fixed" + (props.showScrollTop ? " active" : "")}>
      <div className="calendar_range">
        <p>
          Activity logs for{" "}
          <span className="semi_strong">{userDetails.firstname}</span> from{" "}
          <span className="range semi_strong">
            {epocToDate(props.enterDates.startDate.value, "MM-dd-yyyy")}
          </span>{" "}
          to{" "}
          <span className="range semi_strong">
            {epocToDate(props.enterDates.endDate.value, "MM-dd-yyyy")}
          </span>
        </p>
        <div className="print_activity_logs">
          <a className={`pal_wrap just_flex ${pdfDisabled ? "disable" : ""}`}>
            <span className="pts_icon" />

            <span className="pts_title" onClick={!pdfDisabled && downloadPDF}>
              Download PDF
            </span>
          </a>{" "}
        </div>
      </div>
      <div className="web_logs_header">
        <ul>
          <li>
            <div className="web_logs_item">
              <div className="web_logs_des">
                <span>Description</span>
              </div>
              <div
                className={
                  "web_logs_when" +
                  (props.sortByDate
                    ? " web_logs_when_up"
                    : " web_logs_when_down")
                }
              >
                <span onClick={() => props.toggleActivitiesListByDate()}>
                  Date
                </span>
              </div>
              <div className="web_logs_ip">
                <span>IP Address</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userDetails: state.account.userDetails,
    activities: state.activities.list
  };
}

export default connect(mapStateToProps)(React.memo(Header, arePropsEqual));
function arePropsEqual(oldProps, newProps) {
  return deepCompare(oldProps, newProps);
}
